function maOrdGeneararDesdeEncuentro(response) {
  return ('SOMOS UN EXITO!!');
}
function maOrdGeneararDesdeEncuentro(response) {
    let valor = '';
    let valorCambiaPanelLateral = Number;
    const matrizActionValor = [];
    let jsonActionValor = {};
    if (response.siNo) {
      const accionStore = 'setTextoGenerado';
      valorCambiaPanelLateral = 13;
      valor = null;
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    if (response.siNo) {
        const accionStore = 'setEncuentro';
        valorCambiaPanelLateral = 13;
        valor = null;
        jsonActionValor = {
          valor,
          accionStore,
        };
        matrizActionValor.push(jsonActionValor);
      }
    return ([matrizActionValor, valorCambiaPanelLateral]);
  }
  function maOrdInicio(response) {
    let valor = '';
    let valorCambiaPanelLateral = Number;
    const matrizActionValor = [];
    let jsonActionValor = {};
    if (response.cedula) {
      const accionStore = 'setCedulaPaciente';
      valorCambiaPanelLateral = 13;
      // valorCambiaPanelLateral = 0;
      valor = Number(response.cedula);
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    if (response.cedula) {
      const accionStore = 'setIdFormulario';
      valorCambiaPanelLateral = 13;
      // valorCambiaPanelLateral = 0;
      valor = null;
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    if (response.cedula) {
      const accionStore = 'setVariablesFormularios';
      valorCambiaPanelLateral = 13;
      // valorCambiaPanelLateral = 0;
      valor = [];
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    return ([matrizActionValor, valorCambiaPanelLateral]);
  }
  function maOrdSalir(response) {
    let valor = '';
    let valorCambiaPanelLateral = Number;
    const matrizActionValor = [];
    let jsonActionValor = {};
    if (response.cedula) {
      const accionStore = 'setVariablesFormularios';
      valorCambiaPanelLateral = 13;
      // valorCambiaPanelLateral = 0;
      valor = [];
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    return ([matrizActionValor, valorCambiaPanelLateral]);
  }
module.exports.ordenesEstados = function ordenesEstados(action, response) {
  return new Promise((resolve, reject) => {
    switch (action) {
      case 'ma_ord_genearar_desde_encuentro':
        resolve(maOrdGeneararDesdeEncuentro(response));
        break;
      case 'ma_ord_inicio':
        resolve(maOrdInicio(response));
        break;
      case 'ma_ord_crear':
        resolve(maOrdInicio(response));
        break;
      case 'ma_ord_salir':
        resolve(maOrdSalir(response));
        break;
      default:
        reject('Error');
        break;
    }
  });
};



// WEBPACK FOOTER //
// ./src/js/modulosChatBox/ordenes.js